import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n ({
    local: localStorage.getItem('locale') != 'ar' ? "en" : "ar",
    locale: localStorage.getItem('locale') != 'ar' ? "en" : "ar",
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages: {

        /* english language */
        en: {
            auth: {
                //
            },

            app: {
                KWD: 'KWD',
                pay_now: 'Pay Now',
                print: 'Print',
                customer_name: 'Customer Name',
                customer_phone: 'Phone Number',
                details: 'Details',
                amount: 'Amount',
                beneficiary_name: 'Beneficiary Name',
                home: 'Home',
                contact: 'Contact US',
                followUs: 'Follow Us',
                workFields: 'Work Fields',
                readMore: 'Read More',
                faqs: 'FAQs',
                clients: 'Clients',
                testimonials: 'Satisfied Customers',
                quickLinks: 'Quick links',
                support: 'Support',
                contactInfo: 'Contact info',
                apply: 'Apply',
                address: 'Address',
                phone: 'Phone',
                email: 'Email',
                company_name: 'Company Name',
                subject: 'Subject',
                writeMessage: 'Write message',
                letstalk: 'Let`s talk...!',
                sendMessage: 'Send Message',
                loading: 'Loading...',
                our_services: 'Our Services',
                copyright: 'All rights reserved',
                gatetechs: 'Gatetechs',
                message_sent: 'Message Sent Successfully.',
                payment_link_is_expired: 'Your payment link is expired.',
                android: 'Android',
                ios: 'IOS',
            },

        },


        /* arabic language */
        ar: {
            auth: {
                //
            },

            app : {
                KWD: 'دينار كويتى',
                pay_now: 'ادفع الان',
                print: 'طباعة',
                customer_name: 'اسم العميل',
                customer_phone: 'رقم الهاتف',
                details: 'التفاصيل',
                amount: 'المبلغ',
                beneficiary_name: 'اسم المستفيد',
                contact: 'تواصل معنا',
                home: 'الرئيسية',
                followUs: 'تابعنا',
                workFields: 'مجالات العمل',
                readMore: 'المزيد',
                clients: 'العملاء',
                faqs: 'الأسئلة الشائعة',
                testimonials: 'آراء العملاء',
                quickLinks: 'الروابط السريعة',
                support: 'الدعم',
                contactInfo: 'بيانات التواصل',
                apply: 'سجل',
                address: 'العنوان',
                phone: 'رقم الجوال',
                email: 'البريد الإلكتروني',
                company_name: 'اسم الشركة',
                subject: 'الموضوع',
                writeMessage: 'رسالتك',
                letstalk: 'دعنا نتحدث...!',
                sendMessage: 'إرسال',
                loading: 'تحميل',
                our_services: 'خدماتنا',
                copyright: 'جميع الحقوق محفوظة',
                gatetechs: 'بوابة التقنية',
                message_sent: 'تم الارسال بنجاح.',
                payment_link_is_expired: 'انتهت صلاحية رابط الدفع الخاص بك.',
                android: 'أندرويد',
                ios: 'أبل',
            },

        },

    }
})